import React from "react";
import { Modal, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { useTranslation } from "../../../utils/useTranslation";

interface Props {
  visible: boolean;
  containerNo: string;
  onCancel: () => void;
  onConfirm: () => void;
  // Overrides, so removing a shipment can warn through this dialog rather than
  // through a second one that looks the same. Default to the replace wording.
  titleKey?: string;
  messageKey?: string;
  confirmKey?: string;
  confirmDisabled?: boolean;
}

const ChinaShipmentReplaceWarningModal: React.FC<Props> = ({
  visible,
  containerNo,
  onCancel,
  onConfirm,
  titleKey = "replaceShipmentWarningTitle",
  messageKey = "replaceShipmentWarningMessage",
  confirmKey = "continueBtn",
  confirmDisabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <Modal visible={visible} transparent animationType="fade">
      <View style={styles.overlay}>
        <View style={styles.modal}>
          <View style={styles.iconWrap}>
            <MaterialCommunityIcons name="alert-circle-outline" size={32} color="#d97706" />
          </View>
          <Text style={styles.title}>{t(titleKey as any)}</Text>
          <Text style={styles.message}>{t(messageKey as any)}</Text>
          <View style={styles.containerBadge}>
            <Text style={styles.containerBadgeText}>{containerNo}</Text>
          </View>

          <View style={styles.footer}>
            <TouchableOpacity style={styles.cancelBtn} onPress={onCancel}>
              <Text style={styles.cancelBtnText}>{t("cancel")}</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.confirmBtn}
              onPress={onConfirm}
              disabled={confirmDisabled}
            >
              <Text style={styles.confirmBtnText}>{t(confirmKey as any)}</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default ChinaShipmentReplaceWarningModal;

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.4)",
    justifyContent: "center",
    alignItems: "center",
  },
  modal: {
    width: "90%",
    maxWidth: 420,
    backgroundColor: "#fff",
    borderRadius: 14,
    padding: 24,
    alignItems: "center",
  },
  iconWrap: {
    width: 56,
    height: 56,
    borderRadius: 28,
    backgroundColor: "#fffbeb",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 14,
  },
  title: {
    fontSize: 16,
    fontWeight: "700",
    color: "#111",
    textAlign: "center",
    marginBottom: 8,
  },
  message: {
    fontSize: 13,
    color: "#555",
    textAlign: "center",
    lineHeight: 19,
  },
  containerBadge: {
    marginTop: 14,
    backgroundColor: "#f1f5f9",
    borderRadius: 8,
    paddingVertical: 6,
    paddingHorizontal: 14,
  },
  containerBadgeText: {
    fontSize: 13,
    fontWeight: "700",
    color: "#111827",
  },
  footer: {
    flexDirection: "row",
    gap: 10,
    marginTop: 22,
    width: "100%",
  },
  cancelBtn: {
    flex: 1,
    borderWidth: 1,
    borderColor: "#d1d5db",
    borderRadius: 10,
    paddingVertical: 11,
    alignItems: "center",
    backgroundColor: "#fff",
  },
  cancelBtnText: {
    fontSize: 14,
    fontWeight: "600",
    color: "#374151",
  },
  confirmBtn: {
    flex: 1,
    borderRadius: 10,
    paddingVertical: 11,
    alignItems: "center",
    backgroundColor: "#d97706",
  },
  confirmBtnText: {
    fontSize: 14,
    fontWeight: "700",
    color: "#fff",
  },
});
